<template>
  <div class="alert" v-if="alertshow">
    <div class="con">
      <div class="tit">图灵机器人开放平台服务协议</div>
      <div class="btm">
        <div class="fal" @click="unagree">拒绝</div>
        <div class="tru" :class="{active: isRead}" @click="agree">同意<i v-if="!isRead">({{num}}s)</i></div>
      </div>
      <div class="content-wrap">
        <div class="content">
          <p class="p2">一、授权内容</p>
          <p class="p1"> 本协议的授权产品是北京光年无限科技有限公司（以下简称“本公司”）开发的图灵机器人开放平台（以下简称“图灵开放平台”），是采用了本公司拥有自主知识产权的聊天机器人相关服务平台。</p>
          <p class="p1"><i class="fb">【审慎阅读】您在申请注册流程中点击同意本协议之前，请认真阅读本协议。</i>本协议在用户和本公司间具有合同上的法律效力。本协议可由本公司随时更新，用户可在图灵开放平台网站查阅最新版协议内容。如在本公司修改协议后，用户不接受修改后的协议，请立即停止使用聊天机器人相关服务，如用户选择继续使用，将视为已接受修改后的协议。</p>
          <p class="p1">【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与本公司达成一致，成为图灵开放平台的“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。一经注册或使用本协议下任何服务即视为对本协议条款的理解和接受，用户违反本协议时本公司有权按其违反情况限制或停止向用户提供，并有权追究用户的相关责任。</p>
          <p class="p2">二、服务使用</p>
          <p class="p1">1.在您开始注册程序使用图灵开放平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。<i class="fb">若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</i></p>
          <p class="p1">2.在使用图灵开放平台服务时，您应当按图灵开放平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话等），以便图灵开放平台与您联系、确认。<i class="fb">您了解并同意，您有义务保持您提供信息的真实性及有效性。</i></p>
          <p class="p1">3.凡本网站的内容，包括但不限于Logo、文字、图片、动图，版权均属本公司所有，任何媒体、网站或其他任何形式的法律实体和个人均不得转载、链接或以其他方式复制传播。与本公司签订相关协议或已经获得本公司书面授权许可的媒体、网站或其他任何形式的法律实体和个人，应在授权范围内使用，并注明来源“图灵机器人官网” 或来源“图灵机器人开放平台”。</p>
          <p class="p1">4.除非本公司另行声明外，由本公司运营的网站及客户端内所有产品、技术、软件、程序、数据及其他信息（包括文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计、商标、商号、域名等）的所有权利（包括但不限于著作权、商标权、专利权、商业秘密等相关权利）均属本公司所有。任何媒体、网站或其他任何形式的法律实体和个人未经本公司书面授权，不得复制、转载、摘编、修改、链接、镜像或以其他方式展示、传播上述内容。</p>
          <p class="p1">5.本公司对“图灵机器人、TURING ROBOT、图宝”文字和/或LOGO均进行了商标注册保护，图灵机器人的注册商标信息，可见诸于我国公开的商标注册信息中。任何媒体、网站或其他任何形式的法律实体和个人未经本公司的书面许可不得使用上述商标。</p>
          <p class="p2">三、知识产权</p>
          <p class="p1">1.本公司保证，图灵开放平台所涉及的知识产权全部归本公司所有，为本公司开发、设计，并无抄袭、仿冒、节录或改编他人相同或相似功能软件或侵害他人知识产权。</p>
          <p class="p1">2.本公司保证任何第三方都不能因用户按本协议约定方式使用本平台服务而向用户索取任何权利或要求。</p>
          <p class="p1">3.平台涉及一方专有的和非公开的知识、方法以及其它信息，在开发过程中虽为另一方获知或者使用，知识产权仍归原有一方所有。</p>
          <p class="p1">4.本公司保证，本协议中所涉及的合作标的的知识产权不存在任何瑕疵，不会侵犯任何第三方的合法权益。</p>
          <p class="p2">四、保密条款</p>
          <p class="p1">1.本公司尊重并保护所有使用图灵开放平台用户的个人隐私，您注册时所授权使用或填写的个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，图灵开放平台不会主动向第三方披露。资料应包括但不限于双方提供的一切设计开发有关的信息、结果，以及协议联系期间双方或双方代表与对方交流的对方以前未知的信息。</p>
          <p class="p1">2.本公司不允许任何人在未经用户同意的情况利用本公司提供的服务以任何手段编辑、出售、传播用户的资料。一经发现用户实施上述行为，本公司有权立即终止与该用户的服务协议，终止为其提供任何聊天机器人服务，并有权追究其法律责任。</p>
          <p class="p2 fb">五、免责声明</p>
          <p class="p1 fb">1.图灵开放平台是一个向开发者提供聊天对话技术服务的开放平台，如任何单位或个人开发者基于图灵开放平台提供的聊天对话技术进行开发、发布、传送、传播、储存违反国家法律法规禁止的内容，或利用机器人在虚拟软件模拟真人进行诈骗、诱骗等违法行为导致他人的经济利益受到损失，由此所产生的一切法律责任均与本公司无关。</p>
          <p class="p1 fb">2.如发现用户违反授权协议条约的行为，本公司有权进行独立判断并随时限制、冻结或终止该账号的使用。由此给违规者带来的数据、经济或其他损失，由违规者自行承担。</p>
          <p class="p1 fb">3.鉴于聊天机器人关联服务需要网络支撑，本公司有权对提供网路服务的平台或相关设备进行部分或全部的维护、切换，如因此类情况造成的网络服务在一定时间内出现中断，本公司无需通知用户，也无需承担任何责任。</p>
          <p class="p1 fb">4.如图灵开放平台的系统发生故障影响到所提供服务的正常运行，图灵开放平台承诺在第一时间内与相关单位配合，及时处理进行修复。但用户因此而产生的经济损失，本公司不承担责任。此外，图灵开放平台保留不经事先通知进行维修保养、升级或其他目的暂停本服务任何部分的权利。对此，请用户知悉并及时保存资料，否则，因此导致用户资料丢失，图灵开放平台不承担任何责任。</p>
          <p class="p2">六、协议终止</p>
          <p class="p1">1.如遇下列情况之一，经一方发出书面通知后即可提前终止协议：</p>
          <p class="p3">）任何一方严重违反本协议的实质性义务，经守约方书面通知（书面形式包括通知函、传真、以及邮件等方式）后，在规定期限内未能采取有效的补救措施以纠正违约行为的；</p>
          <p class="p3">2）除适用破产法所禁止的情形外，如果任何一方出于债权人的利益，已被指定接收人或资产受让人、或破产或无力偿付到期债务或因其他事由丧失履约能力；本协议无论因何种原因终止后，本协议保密、知识产权、抗辩、违约责任及其他依其性质应继续有效的条款应继续有效，并不损害受损方寻求其它救济的权利。</p>
          <p class="p1">2.用户应按照本公司的标准规定使用本平台，如用户出现违反授权协议条约的行为，则本公司有权未经通知用户即停止向用户提供聊天机器人服务，终止协议。</p>
          <p class="p2">七、其它条款</p>
          <p class="p1">1. 本公司对本协议条款拥有最终解释权。</p>
          <p class="p1">2. 执行本协议所发生的以及与本协议有关的一切争议，双方友好协商解决，若协商不成，双方同意提交本公司所在地人民法院诉讼解决。</p>
        </div>
      </div>

      <span @click="close">×</span>
    </div>
  </div>
</template>

<script>
    export default{
      props: {
        alertshow: {
          type: Boolean
        }
      },
      data () {
        return {
          timer: null,
          isRead: false,
          num: 5
        };
      },
      watch: {
        alertshow: function (val, oldVal) {
          console.log(1);
          this.toRead();
        }
      },
      beforeDeatory () {
        this.num = 5;
        clearInterval(this.timer);
      },
      methods: {
        toRead () {
          clearInterval(this.timer);
          this.num = 5;
          var _this = this;
          this.timer = setInterval(function () {
            _this.num = _this.num - 1;
            if (_this.num <= 0) {
              _this.num = 0;
              clearInterval(_this.timer);
              _this.isRead = true;
            }
          }, 1000);
        },
        close () {
          this.$emit('close');
          clearInterval(this.timer);
          this.num = 5;
        },
        agree () {
          if (!this.isRead) {
            return false;
          } else {
            this.$parent.onoff = true;
            this.$emit('agree');
            clearInterval(this.timer);
            this.num = 5;
          }
        },
        unagree () {
          this.$emit('unagree');
          clearInterval(this.timer);
          this.num = 5;
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  .alert{position: fixed;left: 0;right: 0;top: 0;bottom: 0;background: rgba(0,0,0,.5);z-index: 1000;
    .con{width: 544px;height: 80%; background: #fff;margin: 5% auto;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.3);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.3);box-shadow:0 0 5px 0 rgba(0,0,0,.3);padding:0 30px;position: relative;min-height: 500px;  }
    .tit{height: 56px; line-height: 56px;padding-top: 15px;border-bottom:#ddd solid 1px;font-size: 16px;color: #333;position: absolute;top: 0;left: 30px;right: 30px; }
    .btm{height: 100px;border-top:#ddd solid 1px;position: absolute;bottom: 0;left: 30px;right: 30px;
    div{width: 88px; height: 35px; line-height: 35px; text-align: center;float: right;color: #fff;margin-top: 20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;cursor: pointer;}
      .fal{margin-left: 10px;background: #bac7d8;}
      .tru{background: #bac7d8;}
      .active {background: #00a3f0;}
    }
    span{position: absolute;right: 40px; top: 20px;font-size: 30px;color: #bac7d8;cursor: pointer;}
    .content-wrap{position: absolute;left: 30px;right: 30px;top: 72px;bottom:101px;overflow: hidden;}
    .content{overflow-y: scroll;width: 564px;height: 100%;}
    .p1{line-height: 18px;font-size: 12px;color: #666;padding-top: 20px;}
    .p2{font-size: 14px;color: #333;padding-top: 30px;}
    .p3 {font-size: 12px;color: #333;padding-top: 10px; line-height: 18px;text-indent: 12px;}
    .fb {font-weight:bold;font-style:normal;}
  }
</style>



// WEBPACK FOOTER //
// agreement.vue?265e161a